export const NAV = {
  logo: 'nav-logo',
  linkHome: 'nav-link-home',
  linkSerrurerie: 'nav-link-serrurerie',
  linkMetallerie: 'nav-link-metallerie',
  linkVitrerie: 'nav-link-vitrerie',
  linkDepannage: 'nav-link-depannage',
  linkRealisations: 'nav-link-realisations',
  linkApropos: 'nav-link-apropos',
  linkContact: 'nav-link-contact',
  ctaCall: 'nav-cta-call',
  ctaQuote: 'nav-cta-quote',
  menuOpen: 'nav-menu-open',
  menuClose: 'nav-menu-close',
  mobileMenu: 'nav-mobile-menu',
};

export const HERO = {
  root: 'hero-root',
  title: 'hero-title',
  subtitle: 'hero-subtitle',
  ctaQuote: 'hero-cta-quote',
  ctaCall: 'hero-cta-call',
};

export const HOMEPAGE = {
  services: 'home-services',
  serviceCard: (slug) => `home-service-${slug}`,
  reasons: 'home-reasons',
  gallery: 'home-gallery',
  cta: 'home-cta-final',
};

export const CONTACT = {
  form: 'contact-form',
  firstName: 'contact-first-name',
  lastName: 'contact-last-name',
  phone: 'contact-phone',
  email: 'contact-email',
  service: 'contact-service',
  urgency: 'contact-urgency',
  address: 'contact-address',
  city: 'contact-city',
  postal: 'contact-postal',
  description: 'contact-description',
  budget: 'contact-budget',
  date: 'contact-date',
  consent: 'contact-consent',
  submit: 'contact-submit',
  success: 'contact-success',
  error: 'contact-error',
};

export const FLOAT = {
  call: 'floating-call',
  quote: 'floating-quote',
  toTop: 'floating-to-top',
};

export const BACK = { root: 'back-button' };

export const REAL = {
  filter: (slug) => `real-filter-${slug}`,
  item: (id) => `real-item-${id}`,
  lightbox: 'real-lightbox',
  lightboxClose: 'real-lightbox-close',
  lightboxNext: 'real-lightbox-next',
  lightboxPrev: 'real-lightbox-prev',
};
